import { normalizarCnpj } from './normalizar-cnpj';

/**
 * Aplica a máscara de formatação a um CNPJ normalizado.
 *
 * Formato resultante: `XX.XXX.XXX/XXXX-XX`
 *
 * Esta função não valida o conteúdo do CNPJ — apenas aplica a máscara posicional.
 * Para validar antes de formatar, use `validarCnpj` e então `formatarCnpj` com
 * o `cnpjNormalizado` do resultado.
 *
 * @param valorNormalizado - CNPJ com exatamente 14 caracteres, sem máscara, em maiúsculas.
 * @returns CNPJ no formato `XX.XXX.XXX/XXXX-XX`.
 * @throws {Error} Se o valor não possuir exatamente 14 caracteres.
 */
export function formatarCnpj(valorNormalizado: string): string {
  if (valorNormalizado.length !== 14) {
    throw new Error(
      `Não é possível formatar: o CNPJ normalizado deve ter exatamente 14 caracteres, ` +
        `mas recebeu ${valorNormalizado.length}.`,
    );
  }
  return (
    valorNormalizado.substring(0, 2) +
    '.' +
    valorNormalizado.substring(2, 5) +
    '.' +
    valorNormalizado.substring(5, 8) +
    '/' +
    valorNormalizado.substring(8, 12) +
    '-' +
    valorNormalizado.substring(12, 14)
  );
}

/**
 * Normaliza e aplica a máscara de formatação a um CNPJ em uma única operação.
 *
 * Combina `normalizarCnpj` seguido de `formatarCnpj`.
 * Aceita entrada com ou sem máscara, em qualquer capitalização.
 *
 * @param valor - CNPJ com ou sem máscara, em qualquer capitalização.
 * @returns CNPJ no formato `XX.XXX.XXX/XXXX-XX`.
 * @throws {Error} Se o valor normalizado não possuir exatamente 14 caracteres.
 */
export function aplicarMascaraCnpj(valor: string): string {
  return formatarCnpj(normalizarCnpj(valor));
}
